import store from "../../app/store/store";
import { USER_ROLES } from "../../app/enum/UserRoles";
import { isClientFinancialEnabled, isFinancialClientUser, isDocumentCadenceEnabled, isFinancialAdminPreviewUser, isFinancialBillingConsultationEnabled } from "../../app/utils/FeatureFlags";

export default () => {
  const { auth } = store.getState();

  const user = auth?.user;
  const profile = user?.role;
  const documentCadenceEnabled = isDocumentCadenceEnabled();
  const menu = {
    header: {
      self: {},
      items: [],
    },
    aside: {
      self: {},
      items: [],
    },
  };

  var idMenuItem = [];

  idMenuItem = [1, 2, 3];

  if (profile === USER_ROLES.CLIENT) {
    menu.aside.items.push({
      title: "DASHBOARD",
      root: true,
      icon: "dashboard",
      bullet: "dot",
      page: "admin/dashboard",
    });
  }

  if (isClientFinancialEnabled() && isFinancialClientUser(user)) {
    menu.aside.items.push({ title: "Meu financeiro", root: true, icon: "cash", bullet: "dot", page: "admin/meu-financeiro" });
  }

  if ([USER_ROLES.ADMIN, USER_ROLES.COLLABORATOR].includes(profile)) {
    menu.aside.items.push({
      title: "DASHBOARD",
      root: true,
      icon: "dashboard",
      bullet: "dot",
      page: "admin/dashboard",
    });

    menu.aside.items.push({
      title: "PARAMETRIZAÇŌES",
      root: true,
      icon: "adjustments",
      bullet: "dot",
      page: "admin/parametrizacao",
    });
    if (profile === USER_ROLES.ADMIN) {
      menu.aside.items.push({
        title: "Financeiro",
        root: true,
        icon: "cash",
        bullet: "dot",
        page: "admin/financeiro",
        toggle: "click",
        submenu: [
          { title: "Painel financeiro", page: "admin/financeiro", exact: true },
          ...(isFinancialBillingConsultationEnabled() && isFinancialAdminPreviewUser(user) ? [{ title: "Conferência de cadastros", page: "admin/financeiro/conferencia", exact: true }] : []),
          { title: "Cobranças", page: "admin/financeiro/cobrancas", exact: true },
          { title: "Envios financeiros", page: "admin/financeiro/envios", exact: true },
          { title: "Ligações e custos", page: "admin/financeiro/ligacoes", exact: true },
        ],
      });
    }
    menu.aside.items.push({
      title: "LOGS",
      root: true,
      icon: "adjustments",
      bullet: "dot",
      page: "admin/logs",
    });
    menu.aside.items.push({
      title: "PUBLICAÇÕES",
      root: true,
      icon: "lawsuit",
      bullet: "dot",
      page: "admin/publicacoes",
    });
    menu.aside.items.push({
      title: "ASSISTENTE",
      root: true,
      icon: "adjustments",
      bullet: "dot",
      page: "admin/assistente",
    });
    if (documentCadenceEnabled) {
      menu.aside.items.push({
        title: "PENDÊNCIAS DOC.",
        root: true,
        icon: "document",
        bullet: "dot",
        page: "admin/cadencia-documental",
      });
    }
  }

  if (
    idMenuItem.includes(1) &&
    [USER_ROLES.ADMIN, USER_ROLES.CLIENT, USER_ROLES.COLLABORATOR].includes(
      profile
    )
  ) {
    if (profile !== USER_ROLES.CLIENT) {
      menu.aside.items.push({
        title: "USUÁRIOS",
        root: true,
        icon: "users-profile",
        bullet: "dot",
        page: "admin/usuario",
      });
    }

    menu.aside.items.push(
      {
        title: "PROCESSOS",
        root: true,
        icon: "lawsuit",
        bullet: "dot",
        page: "admin/processo",
      },
      {
        title: "DOCUMENTOS",
        root: true,
        icon: "document",
        bullet: "dot",
        page: "admin/acompanhamentoDocumentos",
      }
    );
  }
  return menu;
};
